import React, { useContext, useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";
import { BsChevronDown } from 'react-icons/bs';
import { BsPerson } from 'react-icons/bs';
import { BsCash } from 'react-icons/bs';

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);
  const theme = localStorage.getItem('theme')


  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `Play Kkadda Ludo and earn 10000 daily.  बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
   दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 3% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 5% commission दिया जायेगा  Kk  Adda पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो https://kkadda.in/login/${user.referral_code}
    100% भरोसेमंद प्लेटफार्म । 24 hours Live Chat & Call Support  
    
    Your ReferralCode is -${user.referral_code}.`


  // language 

  const shareText = `Play Kkadda Ludo and earn ₹10000 daily. बम्पर धमाका ऑफर 💸💸💸 💥💥💥 दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहाँ आपको Win पर 2% Refer Commission मिलेगा। अगर आपका दोस्त आपके रेफर से गेम खेलता है तो आपको 6% Commission मिलेगा। Kk Adda पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो।  100% भरोसेमंद प्लेटफार्म। 24 Hours Live Chat & Call Support. https://kkadda.in/login/${user.referral_code}
`;

const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;


  const translations = {
    hi: {
      referral: 'आपकी रेफरल कमाई',
      referPerson: 'आमंत्रित किये दोस्त | ',
      referEarn: 'रेफरल कमाई  ',
      referCode: 'रेफरल कोड ',
    },
    en: {
      referral: 'Your Referral Earnings',
      referPerson: 'Referred Players',
      referEarn: 'Referral Earning',
      referCode: 'Referral Code',
    },
  };

  // change theme 

  const styles = {
    backgroundColor: theme === 'light' ? '#eefdd3' : 'black',
    color: theme === 'light' ? 'black' : 'black',
  };
  const styles1 = {
    color: theme === 'light' ? 'black' : 'white',
  };


  return (
    <>
      {/* <Header user={user} /> */}
      <div style={styles}>
        <div
          className="leftContainer"
          style={{ ...styles, minHeight: "100vh", height: "100%" }}
        >
          <section className="refer_page_main_section " >
            {/* <div class="page_heading_div text-center" ><h2 style={{ ...styles1 }}>Refer</h2><p style={{ ...styles1 }}>You can earn more more real money doing refer to your friends.</p></div> */}

            <div className="support_box bg-gradent mt-0 mb-4">
              <img className="w-35 mb-3" src="./images/refer.png" />
              <div class="support_content">
                <h2 className="animated-text mb-1">Refer</h2>
                <p className="mb-0">You can earn more more real money doing refer to your friends</p>
              </div>
            </div>
            <div className=" refrer-box">
              <div className="refer_page_top_main_box" >
                <h2 className="profile_headings">{translations[language].referCode}</h2>
              </div>
              <div>
                <div className="Refer_code" >
                  <h3 style={{ ...styles, border: "1px solid" }}>{user.referral_code}</h3>

                  <button onClick={(e) => copyCode(e)}>Copy</button>
                </div>
              </div>
            </div>
            <hr />

            {/* <div className="or_div" >
                  {" "}
                  <h2>OR</h2>{" "}
                </div> */}
            <div className="whatsapp_share_btn">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                <BsWhatsapp className="icons" />
                <span class="ml-2">Whatsapp</span>
              </a>
            </div>

            {/* <div className="refer_page_top_main_box_outer ">
              <div className="refer_page_top_main_box">
                <h2 className="profile_headings">{translations[language].referral}</h2>
              </div>
              <div className="refer_page_top_main_box_inner">
                <div className="d-flex  mr-auto">
                  <div class="support-icon bg-info"> <BsPerson className="icons text-white" /></div>
                  <div className=" ml-2 refer_page_top_main_box_inner_single bo_le">
                    <h3 style={styles}>{translations[language].referPerson}</h3>
                    <h4 style={styles}>{user.referral_user?.length}</h4>
                   
                  </div>
                </div>
                <div className="d-flex">
                  <div class="support-icon bg-success"><BsCash className="icons text-white" /></div>
                  <div className=" ml-2 refer_page_top_main_box_inner_single">
                    <h3 style={styles}>{translations[language].referEarn}</h3>
                    <h4 style={styles}>₹{user.referral_earning}</h4>
                  </div>
                </div>

              </div>
            </div> */}

            {/* new */}

            <h2 className="profile_headings mt-3">{translations[language].referral}</h2>
            <div className="referal-grid">
              <div className="Players">
                <h5>{translations[language].referPerson}</h5>
                <h4>{user.referral_user?.length}</h4>
                <div className="player_media">
                  <img className="" src="/trophy.png" />
                </div>
              </div>
              <div className="Players" style={{ backgroundColor: "#eef5ff" }}>
                <h5 >{translations[language].referEarn}</h5>
                <h4 >₹{user.referral_earning}</h4>
                <div className="player_media">
                  <img className="" src="/indian-rupee-money-bag.png" />
                </div>
              </div>
            </div>


            {/* <div style={{ width: "fit-content", marginBottom: "10px" }}>
              <a
                href="https://youtu.be/X0m4MeTRwK4?si=6rsjvpUfNxMs8yUN"
                target="_blank"
              >
                <span
                  className="d-flex align-items-center  btn-md guide_btn"
                  style={{
                    right: "0.5rem",
                    backgroundColor: "#003441",
                    color: "white",
                    borderRadius: "4px",
                    padding: "4px 13px",
                    fontSize: "12px",
                  }}
                >
                  Youtube
                  <img
                    className="ml-2"
                    src={"/images/Homepage/youtube.png"}
                    alt=""
                    width="15px"
                  />
                </span>
              </a>
            </div> */}



            {/* <div className="refer_page_top_main_box_outer mt-5">
              <div className="refer_page_top_main_box">
                <h2 className="profile_headings">How It Works</h2>
              </div>
              <div className="refer_page_top_main_box_inner">
                <div className="refer_rules">
                  <p>
                    1. You can refer and Earn Win 3% and Loss 1% of your
                    referral winning, every time
                  </p>
                  <p>
                    2. Like if your player plays for Kkadda Coin. 10000 and
                    wins, You will get Kkadda Coin. 300 as referral amount.
                  </p>
                </div>
              </div>
            </div> */}
          </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
